const  DematEasySteps =[
    {
        step: '01',
        heading: 'Personal Details',
        content: 'Submit basic Personal Details. All your details are 100% secure with us.',
    },
    {
        step: '02',
        heading: 'Paperless Document',
        content: 'Submit your KYC details online. We’ll update you after verification is complete.',
    },
    {
        step: '03',
        heading: 'E-Sign In',
        content: 'Review and sign your account opening form online, in minutes.',
    }
]

export default DematEasySteps;